import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class SwiperWidget {
    constructor(el) {
        this.el = el;
    }

    init() {
        const section = this.el.closest('section');

        new Swiper(this.el, {
            modules: [Navigation, Pagination],
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 24,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: section.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                0: { slidesPerView: 1.2 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3.2 },
            }
        });
    }
}